
import Translate from "./components/translate.vue";
import SelectLanguage from "./components/select-language.vue";

export const LangPlugin = {
	install(Vue:any, options:any){
		Vue.component("translate", Translate);
		Vue.component("Translate", Translate);
		Vue.component("select-language", SelectLanguage);
		Vue.component("SelectLanguage", SelectLanguage);
	}
};